import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartComponent } from './chart/chart.component';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { ChartLegendComponent } from './chart-legend/chart-legend.component';
import { ChartWrapperComponent } from './chart-wrapper/chart-wrapper.component';

@NgModule({
  declarations: [ChartComponent, ChartLegendComponent, ChartWrapperComponent],
  imports: [CommonModule, SkeletonCommonModule],
  exports: [ChartComponent, ChartWrapperComponent]
})
export class ChartModule {}
